const baseUrl = '/activity-api';
export const activityRoutes = {
  activityLogs: "/Activities",
  activityTypes: '/Activities/activityTypes',
  baseUrl: "".concat(baseUrl),
  batch: batchId => "/Batch/".concat(batchId)
};